import { AnnualStatementStatus, SigningStatus } from "./annual-statement-enums";
import { Tag } from "../common/tag";
import { ApproverStatus } from "../documents/approver-status.enum";
import { ReminderRecord } from "../reminders/reminder-record";
import { ReminderType } from "../reminders/reminder.enum";

export class AnnualStatementRecord {
  documentId: string;
  companyId: string;
  companyName: string;
  acn: string;
  debt: number;
  status: AnnualStatementStatus;
  signingStatus: SigningStatus;
  approverStatus?: ApproverStatus;
  reviewDate: string;
  paymentDeadline: string;
  isPaid: boolean;
  tags: Tag[];
  tagsName: string[];
  accountManagerId: string;
  accountManagerFullName: string;
  partnerManagerId: string;
  partnerManagerFullName: string;
  reminders: ReminderRecord[];
  type: string;

  constructor(documentRecord: Partial<AnnualStatementRecord> = {}) {
    this.documentId = documentRecord.documentId ?? '';
    this.companyId = documentRecord.companyId ?? '';
    this.companyName = documentRecord.companyName ?? '';
    this.acn = documentRecord.acn ?? '';
    this.debt = documentRecord.debt ?? 0;
    this.status = documentRecord.status ?? 0;
    this.signingStatus = documentRecord.signingStatus ?? 0;
    this.approverStatus = documentRecord.approverStatus ?? 0;
    this.reviewDate = documentRecord.reviewDate ?? '';
    this.paymentDeadline = documentRecord.paymentDeadline ?? '';
    this.isPaid = documentRecord.isPaid ?? false;
    this.tags = documentRecord.tags ?? [];
    this.tagsName = documentRecord.tagsName ?? [];
    this.accountManagerId = documentRecord.accountManagerId ?? '';
    this.accountManagerFullName = documentRecord.accountManagerFullName ?? '';
    this.partnerManagerId = documentRecord.partnerManagerId ?? '';
    this.partnerManagerFullName = documentRecord.partnerManagerFullName ?? '';
    this.reminders = documentRecord.reminders ?? [];
    this.type = documentRecord.type ?? '';
  }

  get paymentReminders(): ReminderRecord[] {
    return this.reminders.filter((reminder) => reminder.type === ReminderType.Payment);
  }

  get signingReminders(): ReminderRecord[] {
    return this.reminders.filter((reminder) => reminder.type === ReminderType.Signing);
  }

  static isImportedDocument(annualStatementRecord: Partial<AnnualStatementRecord>): boolean {
    return annualStatementRecord.type == 'с:480:Imported';
  }
}
